module.exports = __webpack_public_path__ + "img/white-horizontal-mobile.11820cb9.png";